import { Tabs, Timeline } from "antd";
import axios from "axios";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ActiveDotIcon, BackIcon, CloseIcon, InactiveDotIcon, LogLogo, MartLogo, NoImageLogo } from "../../../asset";
import Accordion from "../../../component/accordion/Accordion";
import SecondaryButton from "../../../component/button/SecondaryButton";
import MapsSmall from "../../../component/maps/MapsSmall";
import Delete from "../../../component/modal/ModalDelete";
import ModalMaps from "../../../component/modal/ModalMaps";
import Breadcumbs from "../../../component/page-components/breadcumbs/breadcumbs";
import { GROLOG_BASE_URL, GROLOG_ORDER_URL, GROLOG_URL } from "../../../constant/apiConstant";
import { ROUTES } from "../../../constant/routeConstant";
import style from "./OrderRequestAdd.module.css";
import moment from "moment";
import CustomDivider from "../../../component/divider/CustomDivider";
import dayjs from "dayjs";

const OrderRequest = () => {
  const { token, client_id, grolog_account_id, userId } = useSelector(
    (state) => state.auth
  );
  let param = `CLIENT_ID=${client_id}&RESOURCE_USER_ID=${userId}&GROLOG_ACCOUNT_ID=${grolog_account_id}`;

  const { t } = useTranslation();
  const [form, setForm] = useState({});
  const navigate = useNavigate();
  const location = useLocation();
  const [detail, setDetail] = useState([]);
  const [index, setIndex] = useState();
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [isOpenMaps, setIsOpenMaps] = useState(false)

  const [SI, setSI] = useState([]);
  const [indexItem, setIndexItem] = useState();
  const [isOpenItem, setIsOpenItem] = useState(false);
  const [userManagementOpen, setUserManagementOpen] = useState(false)
  const [managementHistoryList, setManagementHistoryList] = useState([])

  useEffect(() => {
    fetchData();
    getManagementHistoryList()
  }, []);

  const api = GROLOG_ORDER_URL
  const doPut = async (endpoint, tkn, data, dispatch, refresh_token) => {
    const url = api + endpoint;
    const method = "PUT";
    const headers = { Authorization: tkn };
    const request = { url, method, headers, data };
    return axios(request);
  };

  const doGet = async (endpoint, tkn, params, dispatch, refresh_token) => {
    const url = api + endpoint;
    const method = "GET";
    const headers = { Authorization: tkn };
    const request = { url, method, headers, params };
    return axios(request);
  };

  const doGetBaseUrl = async (endpoint, tkn, params, dispatch, refresh_token) => {
    const url = GROLOG_BASE_URL + endpoint;
    const method = "GET";
    const headers = { "Authorization": token };
    const request = { url, method, headers, params };
    return axios(request);
  };

  const getManagementHistoryList = async () => {
    let res = await doGetBaseUrl(`audit/v1/grolog/audit?page=1&filter=table_name eq order, primary_key eq ${location.state.id}`)

    const data = res?.data?.payload
    const reorderedData = []

    for (let i = data.length - 1; i >= 0; i--) {
      const element = data[i];
      reorderedData.push(element)
    }

    setManagementHistoryList(reorderedData)
  }

  const convertTimestamp = (timestamp, isSpecific) => {
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    const monthNumbers = ["01", "02", "03", "04", "05", "06",
      "07", "08", "09", "10", "11", "12"
    ];

    // Extract components from the timestamp string
    const year = timestamp?.substring(0, 4);
    const month = timestamp?.substring(5, 7) - 1; // Months in JavaScript are 0-indexed
    const day = timestamp?.substring(8, 10);

    let dateFormat = new Date(year, month, day);

    if (isSpecific) {
      return (`${dateFormat.getDate()}-${monthNames[dateFormat.getMonth()]}-${dateFormat.getFullYear()}`)
    } else {
      return (`${dateFormat.getDate()}/${monthNumbers[dateFormat.getMonth()]}/${dateFormat.getFullYear()}`)
    }
  }

  const convertToTime = (timestamp) => {
    let time = new Date(timestamp);
    return (moment(timestamp).utc().format('HH:mm'))
  }

  const fetchData = async () => {
    let id = 1;
    let tkn = `Grolog2023`;
    let res = await doGet(`/order/${location.state.id}?${param}`, token);
    setDetail(res?.data?.payload?.data);
    setSI(res?.data?.payload?.data?.sales_invoice_list);
  };

  console.log("detaill", detail?.updated_at);
  const backToList = () => {
    navigate(ROUTES.ORDER_REQUEST.LIST);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const clickCard = async(i, open, id) => {
    // setIndex(i);
    // setIsOpen(isOpen ? false : true);
    if(detail?.order_by === "Gromart"){
      if(i===index){
        setIsOpen(false);
        setIndex()
        }else{
        setIndex(i);
        setIsOpen(true);
        let res = await doGet(`/gromart-order/sales-invoice/${id}?${param}`, token);
        // setSI(res?.data?.payload?.data);
        let items = [...SI];
        items[i]["item"] = res?.data?.payload?.data;
        setSI(items);
        }
    }else{
      if(i===index){
        setIsOpen(false);
        setIndex()
        }else{
        setIndex(i);
        setIsOpen(true);
        }
    }
  };

  const clickCardItem = async (i, open, id) => {
    if(i===indexItem){
      setIsOpenItem(false);
      setIndexItem()
      }else{
    setIndexItem(i);
    setIsOpenItem(isOpenItem ? false : true);
      }
  };

  const Order = () => {
    return (
      <>
        <div className="flex flex-col gap-[40px]">
          <div>
            {/* <h3 className="font-roboto text-[20px] font-bold mb-6 mt-6">
              {t("Order Information")}
            </h3> */}
        <CustomDivider name={"Order Information"} />
            <div className="flex">
              {/* line one */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Order ID")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.order_id}
                  </h4>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Skillset")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242] flex">
                    {/* {detail?.skill_set_list?.map((el)=>{
                      return(
                        el?.skill_set_name
                      )
                    })} */}
                    {detail?.skill_set_list?.map((el, index) => {
                      return (
                        <>
                          <div
                            key={index}
                            className="bg-red-200 px-2 rounded-3xl"
                          >
                            <p className=" font-roboto-medium text-lg font-normal text-white-100">
                              {" "}
                              {el?.skill_set_name}{" "}
                            </p>
                          </div>
                        </>
                      );
                    })}
                  </h4>
                </div>
              </div>
              {/* line two */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Order Number")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.order_number}
                  </h4>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Temperature Category")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    <h4 className="font-roboto text-[20px] text-[#424242] flex">
                      {/* {detail?.skill_set_list?.map((el)=>{
                      return(
                        el?.skill_set_name
                      )
                    })} */}
                      {detail?.temperature_category_list?.map((el, index) => {
                        return (
                          <>
                            <div
                              key={index}
                              className="bg-red-200 px-2 rounded-3xl"
                            >
                              <p className=" font-roboto-medium text-lg font-normal text-white-100">
                                {" "}
                                {el?.temperature_category_name}{" "}
                              </p>
                            </div>
                          </>
                        );
                      })}
                    </h4>
                  </h4>
                </div>
              </div>
              {/* line three */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Order Date")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {moment.parseZone(detail?.order_date).locale("id").format("DD/M/YYYY")} |

                    {moment.parseZone(detail?.order_date).locale("id").format("HH:M")}

                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>

        {
          detail?.order_by ==="Gromart" ?
          <>
           {SI?.map((el, i) => {
              return (
                <div id={i}>
                  <Accordion
                    onClick={() => clickCard(i, isOpen, el?.sales_invoice_id)}
                    index={i}
                    i={index}
                    isOpen={isOpen}
                    address={<>
                     {
                      el?.sales_invoice_number +
                      " - " +
                      el.total_item +
                      " item - " +
                      el?.total_weight +
                      " Kg - " +
                      el?.total_volume
                      // <>m<sup>3</sup></>
                    }
                    m<sup>3</sup>
                    </>}
                    body={
                      <>
                        {isOpen === true && i === index ? (
                          <>
                            <div>
                              <div className="flex flex-col gap-[40px] ml-10">
                                <div>
                                  {/* <h3 className="font-roboto text-[20px] font-bold mb-6 mt-6">
                              {t("Item Detail")}
                            </h3> */}
        <CustomDivider name={"Item Detail"} />
                                  <div className="flex">
                                    {/* line one */}
                                    <div className="gap-[40px] mb-[24px]">
                                      <div className="w-[400px] mb-[24px]">
                                        <label className="font-roboto text-[14px] text-[#818181]">
                                          {t("Sales Invoice Number")}
                                        </label>
                                        <h4 className="font-roboto text-[20px] text-[#424242]">
                                          {el?.sales_invoice_number}
                                        </h4>
                                      </div>
                                      <div className="w-[400px] mb-[24px]">
                                        <label className="font-roboto text-[14px] text-[#818181]">
                                          {t("Total Weight")}
                                        </label>
                                        <h4 className="font-roboto text-[20px] text-[#424242]">
                                          {el?.total_weight} Kg
                                        </h4>
                                      </div>
                                    </div>
                                    {/* line two */}
                                    <div className="gap-[40px] mb-[24px]">
                                      <div className="w-[400px] mb-[24px]">
                                        <label className="font-roboto text-[14px] text-[#818181]">
                                          {t("Sales Invoice Date")}
                                        </label>
                                        <h4 className="font-roboto text-[20px] text-[#424242]">
                                          {el?.sales_invoice_date ? dayjs(el?.sales_invoice_date).format("YYYY/MM/DD") : "-"}
                                        </h4>
                                      </div>
                                      <div className="w-[400px] mb-[24px]">
                                        <label className="font-roboto text-[14px] text-[#818181]">
                                          {t("Total Volume")}
                                        </label>
                                        <h4 className="font-roboto text-[20px] text-[#424242]">
                                          {el?.total_volume} m<sup>3</sup>
                                        </h4>
                                      </div>
                                    </div>
                                    {/* line three */}
                                    <div className="gap-[40px] mb-[24px]">
                                      <div className="w-[400px] mb-[24px]">
                                        <label className="font-roboto text-[14px] text-[#818181]">
                                          {t("Total Item")}
                                        </label>
                                        <h4 className="font-roboto text-[20px] text-[#424242]">
                                          {el?.total_item}
                                        </h4>
                                      </div>
                                      <div className="w-[400px] mb-[24px]">
                                        <label className="font-roboto text-[14px] text-[#818181]">
                                          {t("Total Price")}
                                        </label>
                                        <h4 className="font-roboto text-[20px] text-[#424242]">
                                          Rp. {el?.total_price}
                                        </h4>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div>
                                {el?.item?.map((els, idx) => {
                                  return (
                                    <div id={idx} className="mr-10">
                                      <Accordion
                                        onClick={() =>
                                          clickCardItem(idx, isOpenItem)
                                        }
                                        index={idx}
                                        width="1250px"
                                        i={indexItem}
                                        isOpen={isOpenItem}
                                        address={
                                          els?.product_brand_id +
                                          " - " +
                                          els.product_name +
                                          " - " +
                                          els?.number_of_item +
                                          " Item"
                                        }
                                        body={
                                          <>
                                            {isOpenItem === true &&
                                              idx === indexItem ? (
                                              <>
                                                <div className="flex flex-col gap-[40px] ml-10">
                                                  <div>
                                                    {/* <h3 className="font-roboto text-[20px] font-bold mb-6 mt-6">
                                                      {t("Item Detail")}
                                                    </h3> */}
        <CustomDivider name={"Item Detail"} />
                                                    <div className="flex">
                                                      {/* line one */}
                                                      <div className="gap-[40px] mb-[24px]">
                                                        <div className="w-[400px] mb-[24px]">
                                                          <label className="font-roboto text-[14px] text-[#818181]">
                                                            {t("Item Brand")}
                                                          </label>
                                                          <h4 className="font-roboto text-[20px] text-[#424242]">
                                                            {els?.product_brand_name
                                                              ? els?.product_brand_name
                                                              : "-"}
                                                          </h4>
                                                        </div>
                                                        <div className="w-[400px] mb-[24px]">
                                                          <label className="font-roboto text-[14px] text-[#818181]">
                                                            {t(
                                                              "Number of Item"
                                                            )}
                                                          </label>
                                                          <h4 className="font-roboto text-[20px] text-[#424242]">
                                                            {
                                                              els?.number_of_item
                                                            }{" "}
                                                            Pcs
                                                          </h4>
                                                        </div>
                                                      </div>
                                                      <div className="gap-[40px] mb-[24px]">
                                                        <div className="w-[400px] mb-[24px]">
                                                          <label className="font-roboto text-[14px] text-[#818181]">
                                                            {t("Item Name")}
                                                          </label>
                                                          <h4 className="font-roboto text-[20px] text-[#424242]">
                                                            {els?.product_name
                                                              ? els?.product_name
                                                              : "-"}
                                                          </h4>
                                                        </div>
                                                      </div>

                                                      <div className="gap-[40px] mb-[24px]">
                                                        <div className="w-[400px] mb-[24px]">
                                                          <label className="font-roboto text-[14px] text-[#818181]">
                                                            {t("Item Category")}
                                                          </label>
                                                          <h4 className="font-roboto text-[20px] text-[#424242]">
                                                            {els?.product_category
                                                              ? els?.product_category
                                                              : "-"}
                                                          </h4>
                                                        </div>
                                                      </div>

                                                    </div>

                                                    {/* <div className="flex flex-col gap-[40px] ml-10">
                          <div> */}
                            {/* <h3 className="font-roboto text-[20px] font-bold mb-6 mt-6">
                              {t("Specification Detail")}
                            </h3> */}
        <CustomDivider name={"Specification Detail"} />
                            <div className="flex">
                              {/* line one */}
                              <div className="gap-[40px] mb-[24px]">
                                <div className="w-[400px] mb-[24px]">
                                  <label className="font-roboto text-[14px] text-[#818181]">
                                    {t("Width")}
                                  </label>
                                  <h4 className="font-roboto text-[20px] text-[#424242]">
                                    {els?.width} M
                                  </h4>
                                </div>
                                <div className="w-[400px] mb-[24px]">
                                  <label className="font-roboto text-[14px] text-[#818181]">
                                    {t("Weight")}
                                  </label>
                                  <h4 className="font-roboto text-[20px] text-[#424242]">
                                    {els?.weight} Kg
                                  </h4>
                                </div>
                                <div className="w-[400px] mb-[24px]">
                                  <label className="font-roboto text-[14px] text-[#818181]">
                                    {t("Subtotal Weight")}
                                  </label>
                                  <h4 className="font-roboto text-[20px] text-[#424242]">
                                    {els?.subtotal_weight} Kg
                                  </h4>
                                </div>
                              </div>
                              {/* line two */}
                              <div className="gap-[40px] mb-[24px]">
                                <div className="w-[500px] mb-[24px]">
                                  <label className="font-roboto text-[14px] text-[#818181]">
                                    {t("Height")}
                                  </label>
                                  <h4 className="font-roboto text-[20px] text-[#424242]">
                                    {els?.height} M
                                  </h4>
                                </div>
                                <div className="w-[400px] mb-[24px]">
                                  <label className="font-roboto text-[14px] text-[#818181]">
                                    {t("Volume")}
                                  </label>
                                  <h4 className="font-roboto text-[20px] text-[#424242]">
                                    {els?.volume} m<sup>3</sup>
                                  </h4>
                                </div>
                                <div className="w-[400px] mb-[24px]">
                                  <label className="font-roboto text-[14px] text-[#818181]">
                                    {t("Subtotal Case Weight")}
                                  </label>
                                  <h4 className="font-roboto text-[20px] text-[#424242]">
                                    {els?.subtotal_case_weight} Kg
                                  </h4>
                                </div>
                              </div>
                              {/* line three */}
                              <div className="gap-[40px] mb-[24px]">
                                <div className="w-[500px] mb-[24px]">
                                  <label className="font-roboto text-[14px] text-[#818181]">
                                    {t("Length")}
                                  </label>
                                  <h4 className="font-roboto text-[20px] text-[#424242]">
                                    {els?.length} M
                                  </h4>
                                </div>
                                <div className="w-[400px] mb-[24px]">
                                  <label className="font-roboto text-[14px] text-[#818181]">
                                    {t("Subtotal Volume per Item")}
                                  </label>
                                  <h4 className="font-roboto text-[20px] text-[#424242]">
                                    {els?.subtotal_volume} m<sup>3</sup>
                                  </h4>
                                </div>
                              </div>

                            </div>
                          {/* </div>
                        </div> */}

                                                    {/* <h3 className="font-roboto text-[20px] font-bold mb-6">
                                                      {t("Pallet")}
                                                    </h3> */}
        <CustomDivider name={"Pallet"} />
                                                    <div className="flex">
                                                      {/* line one */}
                                                      <div className="gap-[40px] mb-[24px]">
                                                        <div className="w-[400px] mb-[24px]">
                                                          <label className="font-roboto text-[14px] text-[#818181]">
                                                            {t("Pallet")}
                                                          </label>
                                                          <h4 className="font-roboto text-[20px] text-[#424242]">
                                                            {els?.is_use_pallet === "Y"
                                                              ? "Yes"
                                                              : "No"}
                                                          </h4>
                                                        </div>
                                                        <div className="w-[400px] mb-[24px]">
                                                          <label className="font-roboto text-[14px] text-[#818181]">
                                                            {t("Pallet Name")}
                                                          </label>
                                                          <h4 className="font-roboto text-[20px] text-[#424242]">
                                                            {els?.pallet_name
                                                              ? els?.pallet_name
                                                              : "-"}
                                                          </h4>
                                                        </div>
                                                        <div className="w-[400px] mb-[24px]">
                                                          <label className="font-roboto text-[14px] text-[#818181]">
                                                            {t("Number of Item per Pallet")}
                                                          </label>
                                                          <h4 className="font-roboto text-[20px] text-[#424242]">
                                                            {els?.number_of_item_per_pallet
                                                              ? els?.number_of_item_per_pallet
                                                              : 0}
                                                          </h4>
                                                        </div>
                                                      </div>
                                                    </div>

                                                  </div>
                                                </div>
                                              </>
                                            ) : (
                                              <></>
                                            )}
                                          </>
                                        }
                                      />
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          </>
                        ) : (
                          <></>
                        )}
                      </>
                    }
                  />
                </div>
              );
            })}
          </>
          :
          <></>
        }

        {detail?.order_item_list?.map((el, i) => {
          return (
            <div id={i}>
              <Accordion
                onClick={() => clickCard(i, isOpen)}
                index={i}
                i={index}
                isOpen={isOpen}
                address={el?.item_brand}
                body={
                  <>
                    {isOpen === true && i === index ? (
                      <>

                        <div className="flex flex-col gap-[40px] ml-10">
                          <div>
                            {/* <h3 className="font-roboto text-[20px] font-bold mb-6 mt-6">
                              {t("Item Detail")}
                            </h3> */}
        <CustomDivider name={"Item Detail"} />
                            <div className="flex">
                              {/* line one */}
                              <div className="gap-[40px] mb-[24px]">
                                <div className="w-[400px] mb-[24px]">
                                  <label className="font-roboto text-[14px] text-[#818181]">
                                    {t("Item Brand")}
                                  </label>
                                  <h4 className="font-roboto text-[20px] text-[#424242]">
                                    {el?.item_brand}
                                  </h4>
                                </div>
                                <div className="w-[400px] mb-[24px]">
                                  <label className="font-roboto text-[14px] text-[#818181]">
                                    {t("Number of Item")}
                                  </label>
                                  <h4 className="font-roboto text-[20px] text-[#424242]">
                                    {el?.number_of_item} Pcs
                                  </h4>
                                </div>
                              </div>
                              {/* line two */}
                              <div className="gap-[40px] mb-[24px]">
                                <div className="w-[500px] mb-[24px]">
                                  <label className="font-roboto text-[14px] text-[#818181]">
                                    {t("Item Name")}
                                  </label>
                                  <h4 className="font-roboto text-[20px] text-[#424242]">
                                    {el?.item_name}
                                  </h4>
                                </div>
                              </div>
                              {/* line three */}
                              <div className="gap-[40px] mb-[24px]">
                                <div className="w-[400px] mb-[24px]">
                                  <label className="font-roboto text-[14px] text-[#818181]">
                                    {t("Item Category")}
                                  </label>
                                  <h4 className="font-roboto text-[20px] text-[#424242]">
                                    {el?.item_category}
                                  </h4>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="flex flex-col gap-[40px] ml-10">
                          <div>
                            {/* <h3 className="font-roboto text-[20px] font-bold mb-6 mt-6">
                              {t("Specification Detail")}
                            </h3> */}
        <CustomDivider name={"Specification Detail"} />
                            <div className="flex">
                              {/* line one */}
                              <div className="gap-[40px] mb-[24px]">
                                <div className="w-[400px] mb-[24px]">
                                  <label className="font-roboto text-[14px] text-[#818181]">
                                    {t("Width")}
                                  </label>
                                  <h4 className="font-roboto text-[20px] text-[#424242]">
                                    {el?.width} M
                                  </h4>
                                </div>
                                <div className="w-[400px] mb-[24px]">
                                  <label className="font-roboto text-[14px] text-[#818181]">
                                    {t("Weight")}
                                  </label>
                                  <h4 className="font-roboto text-[20px] text-[#424242]">
                                    {el?.weight} Kg
                                  </h4>
                                </div>
                                <div className="w-[400px] mb-[24px]">
                                  <label className="font-roboto text-[14px] text-[#818181]">
                                    {t("Subtotal Weight")}
                                  </label>
                                  <h4 className="font-roboto text-[20px] text-[#424242]">
                                    {el?.subtotal_weight} Kg
                                  </h4>
                                </div>
                              </div>
                              {/* line two */}
                              <div className="gap-[40px] mb-[24px]">
                                <div className="w-[500px] mb-[24px]">
                                  <label className="font-roboto text-[14px] text-[#818181]">
                                    {t("Height")}
                                  </label>
                                  <h4 className="font-roboto text-[20px] text-[#424242]">
                                    {el?.height} M
                                  </h4>
                                </div>
                                <div className="w-[400px] mb-[24px]">
                                  <label className="font-roboto text-[14px] text-[#818181]">
                                    {t("Volume")}
                                  </label>
                                  <h4 className="font-roboto text-[20px] text-[#424242]">
                                    {el?.volume} m<sup>3</sup>
                                  </h4>
                                </div>
                                <div className="w-[400px] mb-[24px]">
                                  <label className="font-roboto text-[14px] text-[#818181]">
                                    {t("Subtotal Case Weight")}
                                  </label>
                                  <h4 className="font-roboto text-[20px] text-[#424242]">
                                    {el?.subtotal_case_weight} Kg
                                  </h4>
                                </div>
                              </div>
                              {/* line three */}
                              <div className="gap-[40px] mb-[24px]">
                                <div className="w-[500px] mb-[24px]">
                                  <label className="font-roboto text-[14px] text-[#818181]">
                                    {t("Length")}
                                  </label>
                                  <h4 className="font-roboto text-[20px] text-[#424242]">
                                    {el?.length} M
                                  </h4>
                                </div>
                                <div className="w-[400px] mb-[24px]">
                                  <label className="font-roboto text-[14px] text-[#818181]">
                                    {t("Subtotal Volume per Item")}
                                  </label>
                                  <h4 className="font-roboto text-[20px] text-[#424242]">
                                    {el?.subtotal_volume} m<sup>3</sup>
                                  </h4>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                        <div className="flex flex-col gap-[40px] ml-10">
                          <div>
                            {/* <h3 className="font-roboto text-[20px] font-bold mb-6 mt-6">
                              {t("Pallet")}
                            </h3> */}
        <CustomDivider name={"Pallet"} />
                            <div className="flex">
                              {/* line one */}
                              <div className="gap-[40px] mb-[24px]">
                                <div className="w-[400px] mb-[24px]">
                                  <label className="font-roboto text-[14px] text-[#818181]">
                                    {t("Pallet")}
                                  </label>
                                  <h4 className="font-roboto text-[20px] text-[#424242]">
                                    {el?.is_use_pallet}
                                  </h4>
                                </div>
                              </div>
                              {
                                el?.is_use_pallet === "Y" ?
                                  <>
                                    <div className="gap-[40px] mb-[24px]">
                                      <div className="w-[400px] mb-[24px]">
                                        <label className="font-roboto text-[14px] text-[#818181]">
                                          {t("Pallet")}
                                        </label>
                                        <h4 className="font-roboto text-[20px] text-[#424242]">
                                          {el?.pallet_name}
                                        </h4>
                                      </div>
                                    </div>
                                    <div className="gap-[40px] mb-[24px]">
                                      <div className="w-[400px] mb-[24px]">
                                        <label className="font-roboto text-[14px] text-[#818181]">
                                          {t("Number of Item per pallet")}
                                        </label>
                                        <h4 className="font-roboto text-[20px] text-[#424242]">
                                          {el?.number_of_item_per_pallet}
                                        </h4>
                                      </div>
                                    </div>
                                  </>
                                  :
                                  <></>
                              }
                            </div>
                          </div>
                        </div>
                      </>
                    ) : null}
                  </>
                }
              />
            </div>
          );
        })}
      </>
    );
  };

  const Delivery = () => {
    return (
      <>
        <ModalMaps show={isOpenMaps}
          address={detail.address}
          latitude={detail.latitude}
          longitude={detail.longitude}
          onClose={() => setIsOpenMaps(false)}
        />
        <div className="flex flex-col gap-[40px]">
          <div>
            {/* <h3 className="font-roboto text-[20px] font-bold mb-6 mt-6">
              {t("Customer Information")}
            </h3> */}
        <CustomDivider name={"Customer Information"} />
            <div className="flex">
              {/* line one */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Customer ID")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.customer_id}
                  </h4>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Customer Phone")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.customer_phone}
                  </h4>
                </div>
              </div>
              {/* line two */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Customer Profile ID")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.customer_profile_id}
                  </h4>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Customer Fax")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.customer_fax ? detail?.customer_fax : "-"}
                  </h4>
                </div>
              </div>
              {/* line three */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Customer Email")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.customer_email}
                  </h4>
                </div>
              </div>
            </div>
           
          </div>
        </div>
        <div className="flex flex-col gap-[40px]">
          <div>
            {/* <h3 className="font-roboto text-[20px] font-bold mb-6 mt-6">
              {t("Customer Address")}
            </h3> */}
        <CustomDivider name={"Customer Address"} />
            <div className="flex">
              {/* line one */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Country")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.country_name}
                  </h4>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("District")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.district_name}
                  </h4>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Address")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.address}
                  </h4>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Neighbourhood")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.neighbourhood ? detail?.neighbourhood : "-"}
                  </h4>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Longitude")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.longitude}
                  </h4>
                </div>
              </div>
              {/* line two */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Island")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.island_name}
                  </h4>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Sub District")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.sub_district_name}
                  </h4>
                </div>
                {/* <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Address 2")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.address_2}
                  </h4>
                </div> */}
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Hamlet")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.hamlet ? detail?.hamlet : "-"}
                  </h4>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Latitude")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.latitude}
                  </h4>
                </div>
              </div>
              {/* line three */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Province")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.province_name}
                  </h4>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Urban Village")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.urban_village_name}
                  </h4>
                </div>
                {/* <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Address 3")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.address_3}
                  </h4>
                </div> */}
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Postal Code")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.postal_code}
                  </h4>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Pinpoin")}
                  </label>
                  <MapsSmall
                    long={detail?.longitude}
                    lat={detail?.latitude}
                    onClicks={() => setIsOpenMaps(true)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

{
  detail?.status === "Received" ? 
  <>
  
        {/* <h3 className="font-roboto text-[20px] font-bold mb-6 mt-6">
              {t("Receieve Information")}
            </h3> */}
        <CustomDivider name={"Receieve Information"} />
                     
        <div className="flex">
                        {/* //one */}
                         <div className="gap-[40px] mb-[24px]">
                          <div className="w-[350px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Receipt Name")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {detail?.receive_information?.receipt_name
                                ? detail?.receive_information?.receipt_name
                                : "-"}
                            </h4>
                          </div>
                          <div className="w-[350px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Previous Trip")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {detail?.receive_information?.previous_trip
                                ? detail?.receive_information?.previous_trip
                                : ""}
                            </h4>
                          </div>
                          <div className="w-[350px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Trip Route Sequence")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {detail?.receive_information?.trip_route_sequence
                                ? detail?.receive_information?.trip_route_sequence
                                : "-"}
                            </h4>
                          </div>
                          <div className="w-[350px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Trip Route Cost")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {detail?.receive_information?.trip_route_cost
                                ? detail?.receive_information?.trip_route_cost
                                : "-"}
                            </h4>
                          </div>
                          <div className="w-[350px] mb-[24px] flex">
                            <div>
                              <label className="font-roboto text-[14px] text-[#000000]">
                                {t("Receive Image")}
                              </label>
                              <div className="aspect-square border-[2px] w-28 text-[#424242] border-gray-100 p-6 rounded-xl">
                                <img
                                  className="aspect-square"
                                  src={
                                    detail?.receive_information?.receive_image_url
                                      ? detail?.receive_information?.receive_image_url
                                      : NoImageLogo
                                  }
                                  alt="photoh"
                                />
                              </div>
                            </div>
                            <div className="ml-2">
                              <label className="font-roboto text-[14px] text-[#000000]">
                                {t("Signature Image")}
                              </label>
                              <div className="aspect-square border-[2px] w-28 text-[#424242] border-gray-100 p-6 rounded-xl">
                                <img
                                  className="aspect-square"
                                  src={
                                    detail?.receive_information?.signature_image_url
                                      ? detail?.receive_information?.signature_image_url
                                      : NoImageLogo
                                  }
                                  alt="photoh"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* line two */}
                        <div className="gap-[40px] mb-[24px]">
                          <div className="w-[350px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Routes Distance")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {detail?.receive_information?.routes_distance
                                ? detail?.receive_information?.routes_distance
                                : "-"}
                            </h4>
                          </div>
                          <div className="w-[350px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Routes Estimation Time")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {detail?.receive_information?.routes_estimation_time
                                ? detail?.receive_information?.routes_estimation_time+" Minutes"
                                : "-"}
                            </h4>
                          </div>
                          <div className="w-[350px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Routes Status")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {detail?.receive_information?.routes_status
                                ? detail?.receive_information?.routes_status
                                : "-"}
                            </h4>
                          </div>
                          <div className="w-[350px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Trip Routes Start Delivery")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {detail?.receive_information?.trip_route_start_delivery
                                ? detail?.receive_information?.trip_route_start_delivery
                                : "-"}
                            </h4>
                          </div>
                        </div>
                        {/* line three */}
                        <div className="gap-[40px] mb-[24px]">
                          <div className="w-[350px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Trip Routes Finished Delivery")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {detail?.receive_information?.trip_route_finished_delivery
                                ? detail?.receive_information?.trip_route_finished_delivery
                                : "-"}
                            </h4>
                          </div>
                          <div className="w-[350px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Trip Route Start Pickup")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {detail?.receive_information?.trip_route_start_pickup
                                ? detail?.receive_information?.trip_route_start_pickup
                                : "-"}
                            </h4>
                          </div>
                          <div className="w-[350px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Trip Route Finished Pickup")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {detail?.receive_information?.trip_route_finished_pickup
                                ? detail?.receive_information?.trip_route_finished_pickup
                                : "-"}
                            </h4>
                          </div>
                          <div className="w-[350px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Waiting Time")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {detail?.receive_information?.waiting_time
                                ? detail?.receive_information?.waiting_time
                                : "-"}
                            </h4>
                          </div>
                        </div>
                      </div>
                      </>
  :
  <>
  </>
}
      </>
    );
  };

  const Total = () => {
    return (
      <>
        <div className="flex flex-col gap-[40px]">
          <div>
            {/* <h3 className="font-roboto text-[20px] font-bold mb-6 mt-6">
              {t("Order Information")}
            </h3> */}
        <CustomDivider name={"Order Information"} />
            <div className="flex">
              {/* line one */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Priority Delivery")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.order_priority === 1 ? "Urgent" : detail?.order_priority === 2 ? "High" : detail?.order_priority === 3 ? "Medium" : "Low"}
                  </h4>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Total Order Weight")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.total_order_weight} Kg
                  </h4>
                </div>
              </div>
              {/* line two */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Delivery Type")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.delivery_type}
                  </h4>
                </div>
                
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Total Order Volume")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.total_order_volume} m<sup>3</sup>
                  </h4>
                </div>
              </div>
              {/* line two */}
              <div className="gap-[40px] mb-[24px]">
              <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Shipping Cost")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    Rp. {detail?.total_cost_delivery_type ? detail?.total_cost_delivery_type : 0}
                  </h4>
                </div>
                
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Delivery Notes")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.delivery_notes}
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-[40px]">
          <div>
            {/* <h3 className="font-roboto text-[20px] font-bold mb-6 mt-6">
              {t("Price Detail")}
            </h3> */}
        <CustomDivider name={"Price Detail"} />
            <div className="flex">
              {/* line one */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Total Price")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    Rp. {detail?.total_price}
                  </h4>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Height")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.total_height} M
                  </h4>
                </div>
              </div>
              {/* line two */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Length")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.total_length} M
                  </h4>
                </div>
              </div>
              {/* line one */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Width")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.total_width} M
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const items = [
    {
      key: 1,
      label: t("Order Detail"),
      children: Order(),
    },
    {
      key: 2,
      label: t("Delivery Detail"),
      children: Delivery(),
    },
    {
      key: 3,
      label: t("Total Order"),
      children: Total(),
    },
  ];

  return (
    <>
      <Delete
        data={detail.updated_at}
        id={detail.order_id}
        delete={showDelete}
        title={detail.first_name}
        url={"order"}
        action={() => setShowDelete(false)}
        route={ROUTES.ORDER_REQUEST.LIST}
        token={token}
        param={param}
      // refresh={fetchData()}
      />
      <div className="p-[24px] flex flex-col gap-[24px]">
        <div>
          <Breadcumbs
            jmlLevel={3}
            menuLevel1={`Order`}
            menuLevel2={`Order Request`}
            menuLevel3={`Detail ` + detail?.order_id + " - " + detail?.order_number}
          />
        </div>

        <div className="flex items-center justify-between">
          <div
            onClick={() => navigate(ROUTES.ORDER_REQUEST.LIST)} className="cursor-pointer flex items-center gap-[22px]">
            <img
              src={BackIcon}
              alt=""
              className="cursor-pointer"
            />
            <h1 className="font-sans-bold text-2xl" id="title">
              Detail {detail?.order_id + " - " + detail?.order_number}
            </h1>
            <img src={detail?.order_by ==="Gromart" ? MartLogo : LogLogo} alt="logo"/>
          </div>
          <div className='bg-[#EEEEEE] rounded-[6px] px-[12px] py-[7px] cursor-pointer' onClick={() => setUserManagementOpen(true)}>
            <p className='text-[#666666]'>{t("USER_DETAIL:CREATED_BY")}  <strong>{detail?.created_by}</strong> {t("USER_DETAIL:ON")} <strong>{convertTimestamp(detail?.created_at, true)}</strong> | {t("USER_DETAIL:LAST_MODIFIED_BY")} <strong>{detail?.updated_by}</strong> {t("USER_DETAIL:ON")} <strong>{convertTimestamp(detail?.updated_at, true)}</strong></p>
          </div>
        </div>

        <div
          style={{
            marginTop: 24,
            padding: 30,
            minHeight: 512,
            borderRadius: "6px",
            backgroundColor: "white",
            boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.16)",
          }}
        >
          <div className={style.tabsContainer + ""}>
            <Tabs
              defaultActiveKey="1"
              items={items}
              className="border-b border-[#ffffff]"
            />
          </div>
        </div>
        <aside className={userManagementOpen ? "duration-300 ease-out transition-all right-0 w-[400px] h-full fixed top-0 z-20 bg-[#FFFFFF] px-[24px] py-[20px] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] overflow-auto" : "duration-300 ease-out transition-all right-[-400px] w-[400px] h-full fixed top-0 z-20 bg-[#FFFFFF] px-[24px] py-[20px] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] overflow-auto"}>
          <button className='absolute top-[21px] right-[21px]' onClick={() => setUserManagementOpen(false)}>
            <img src={CloseIcon} alt="" />
          </button>

          <h3 className='font-sans font-[600] text-[#1D1D1D] text-[20px]'>{t("USER_DETAIL:DATA_MANAGEMENT_HISTORY")}</h3>
          <p className='font-sans font-[400] text-[#818181] text-[12px] mb-[24px]'>{t("USER_DETAIL:CREATED_BY")}  <strong>{detail?.created_by}</strong> {t("USER_DETAIL:ON")} <strong>{convertTimestamp(detail?.created_at)}</strong></p>


          <div className={style.timelineContainer}>
            <Timeline>
              {
                managementHistoryList.map((item, index) => {
                  if (index === 0) {
                    return (
                      <Timeline.Item dot={<img src={ActiveDotIcon} />}>
                        <div className='flex flex-col gap-[8px] border-b-[##DDDDDD] border-b-[1px] pb-[16px]'>
                          <h4 className={"text-[#CF0000] font-[500] text-[14px]"}>{t("USER_DETAIL:LAST_MODIFIED")}</h4>
                          <h4 className='font-[500] text-[14px] text-[#424242]'>{item.alias_name}</h4>
                          <p className='font-[400] text-[14px]'>{`${convertTimestamp(item.created_at)} • ${convertToTime(item.created_at)}`}</p>
                        </div>
                      </Timeline.Item>
                    )
                  } else {
                    return (
                      <Timeline.Item dot={<img src={InactiveDotIcon} />}>
                        <div className='flex flex-col gap-[8px] border-b-[##DDDDDD] border-b-[1px] pb-[16px]'>
                          <h4 className={"font-[500]"}>{t("USER_DETAIL:MODIFIED")}</h4>
                          <h4 className='font-[500] text-[14px] text-[#424242]'>{item.alias_name}</h4>
                          <p className='font-[400] text-[14px]'>{`${convertTimestamp(item.created_at)} • ${convertToTime(item.created_at)}`}</p>
                        </div>
                      </Timeline.Item>
                    )
                  }
                })
              }
            </Timeline>
          </div>
        </aside>
        <div className={`flex flex-row-reverse gap-[16px] `}>
          <SecondaryButton disabled ={location.state.status !== "New"} text={t("DRIVER:DELETE")} action={() => setShowDelete(true)} />
        </div>
      </div>
    </>
  );
};
export default OrderRequest;
